/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsProductSection10 = {
  init: function ($section) {
    
    // Add settings from schema to current object
    // window.PXUTheme.jsProductSection10 = $.extend(this, window.PXUTheme.getSectionData($section));
    this.element = $section[0];
    
    this.delegateElement = new domDelegate.Delegate(this.element);

    this.initTabs();
    
  },
  initTabs() {
    let tabContents = Array.from(this.element.querySelectorAll("dd"));
    tabContents.forEach( item => item.setAttribute("aria-hidden", true));
    let tabButtons = Array.from(this.element.querySelectorAll("dt button"));
    tabButtons.forEach( item => item.setAttribute("aria-expanded", false));
    this.delegateElement.on('click', 'button', this.handleTabs.bind(this));
  },
  handleTabs(event, target) {
    let canBeOpened = target.getAttribute("aria-expanded") === 'false' ? true : false;
    let tabs = this.element.querySelectorAll(".Section_10--tab");
    tabs.forEach(tab => {
      if (tab === target.closest(".Section_10--tab") && canBeOpened) {
        this.openTab(tab);
      } else {
        this.closeTab(tab);
      }
    });
  },
  openTab(tab) {
    // button
    let button = tab.querySelector("button");
    button.setAttribute("aria-expanded", true);
    // icons
    let icons = Array.from(button.querySelectorAll(".icon"));
    icons.forEach(icon => icon.classList.toggle("icon--active"));
    // content
    let content = tab.querySelector("dd");
    content.setAttribute("aria-hidden", false);
    $(content).slideDown();
  },
  closeTab(tab) {
    // button
    let button = tab.querySelector("button");
    let isOpened = button.getAttribute("aria-expanded") === "true" ? true : false;
    if (!isOpened) return;
    button.setAttribute("aria-expanded", false);
    // icons
    let icons = Array.from(button.querySelectorAll(".icon"));
    icons.forEach(icon => icon.classList.toggle("icon--active"));
    // content
    let content = tab.querySelector("dd");
    content.setAttribute("aria-hidden", true);
    $(content).slideUp();
  }
}

/******/ })()
;